import { createFileRoute } from '@tanstack/react-router'

import { ProductRequestsScreen } from './-components/requests-screen.tsx'

export const Route = createFileRoute('/product/requests')({
  component: ProductRequestsScreen
})
